/**
 * navigation.js — Header navigation (replica de Alpine.js en /waiis-base)
 *
 * Estado gestionado:
 *   menuActive — overlay movil abierto/cerrado
 *   scrolled   — header ha pasado el umbral de scroll
 *   openSubmenu — ID del submenu actualmente abierto (movil)
 */

const SCROLL_THRESHOLD  = 100;
const DESKTOP_BREAKPOINT = 1024;

export function initNavigation() {
	const header  = document.getElementById( 'site-header' );
	const toggle  = document.getElementById( 'nav-toggle' );
	const menu    = document.getElementById( 'site-menu' );
	if ( ! header || ! toggle || ! menu ) return;

	// ── Estado ───────────────────────────────────────────────────────────────
	let menuActive  = false;
	let openSubmenu = null;

	// ── Scroll detection ─────────────────────────────────────────────────────
	function onScroll() {
		header.classList.toggle( 'is-scrolled', window.scrollY > SCROLL_THRESHOLD );
	}
	window.addEventListener( 'scroll', onScroll, { passive: true } );
	onScroll();

	// ── Abrir menu movil ─────────────────────────────────────────────────────
	function openMenu() {
		menuActive = true;
		header.classList.add( 'menu-active' );
		menu.classList.add( 'is-open' );
		toggle.setAttribute( 'aria-expanded', 'true' );
		document.body.style.overflow = 'hidden';
	}

	// ── Cerrar menu movil ────────────────────────────────────────────────────
	function closeMenu() {
		menuActive = false;
		header.classList.remove( 'menu-active' );
		menu.classList.remove( 'is-open' );
		toggle.setAttribute( 'aria-expanded', 'false' );
		document.body.style.overflow = '';
		closeAllSubmenus();
	}

	// ── Toggle hamburguesa ───────────────────────────────────────────────────
	toggle.addEventListener( 'click', () => {
		if ( menuActive ) closeMenu();
		else openMenu();
	} );

	// ── Escape cierra el menu ─────────────────────────────────────────────────
	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && menuActive ) {
			closeMenu();
			toggle.focus();
		}
	} );

	// ── Cierre al cambiar a desktop ──────────────────────────────────────────
	let resizeTimer;
	window.addEventListener( 'resize', () => {
		clearTimeout( resizeTimer );
		resizeTimer = setTimeout( () => {
			if ( window.innerWidth >= DESKTOP_BREAKPOINT && menuActive ) {
				closeMenu();
			}
		}, 100 );
	} );

	// ── Submenus (movil) ─────────────────────────────────────────────────────
	function closeAllSubmenus() {
		menu.querySelectorAll( '.submenu-toggle' ).forEach( ( btn ) => {
			btn.setAttribute( 'aria-expanded', 'false' );
			const submenu = document.getElementById( btn.getAttribute( 'aria-controls' ) );
			if ( submenu ) submenu.classList.remove( 'is-open' );
		} );
		openSubmenu = null;
	}

	menu.querySelectorAll( '.submenu-toggle' ).forEach( ( btn ) => {
		btn.addEventListener( 'click', () => {
			if ( window.innerWidth >= DESKTOP_BREAKPOINT ) return;

			const submenuId = btn.getAttribute( 'aria-controls' );
			const isOpen    = btn.getAttribute( 'aria-expanded' ) === 'true';

			closeAllSubmenus();

			if ( ! isOpen ) {
				btn.setAttribute( 'aria-expanded', 'true' );
				const submenu = document.getElementById( submenuId );
				if ( submenu ) submenu.classList.add( 'is-open' );
				openSubmenu = submenuId;
			}
		} );
	} );

	// ── Smooth-scroll para anclas internas ───────────────────────────────────
	document.querySelectorAll( 'a[href^="#"]' ).forEach( ( anchor ) => {
		anchor.addEventListener( 'click', ( e ) => {
			const target = document.querySelector( anchor.getAttribute( 'href' ) );
			if ( ! target ) return;
			e.preventDefault();
			if ( menuActive ) closeMenu();
			target.scrollIntoView( { behavior: 'smooth', block: 'start' } );
		} );
	} );
}
